import Login from "components/pages/Login"
import { useRedirectLoggedInUsers } from "hooks/misc/useRedirectLoggedInUsers"

export default function LoginPage() {
  useRedirectLoggedInUsers()
  return <Login />
}
